module.exports = ":root{--primary: #5f9ea0}\n"